// this file for common style
import styled from "styled-components";
import { Colors, FontWeight, Size } from "./Library";

// clearfix (common)
function clearFix() {
  return `
      &:after {
        content:" ";display:block;clear:both;line-height:0;height:0
      }
    `;
}


// create LHS & RHS
const LHS = styled.div`float:left`;
const RHS = styled.div`float:right`;

// create a
const MenuLink = styled.a``;


// strong
const Strong = styled.strong`
    font-weight: ${(props) => {
    return FontWeight.fw1000;
  }};
`;

// create multi color handeler for btn
const handleBtnType = btnType => {
  switch (btnType) {
    // follow
    case "follow":
      return "border: 1px solid rgb(234, 235, 234);";

    // following
    case "following":
      return "color:#fff;background:#1f9ee1;border:1px solid #1f9ee1";

    // 3Dot
    case "3Dot":
      return "background-image:url(/static/images/follow.svg);background-repeat:no-repeat;height:22px;width:22px;background-position:center center;top:6px;padding:0.25rem";

    //follow with blue border
    case "followBlue":
      return "border: 1px solid rgb(31, 158, 225);";

    default:
      return "color:#959595;padding:0.625rem";

  }
};

// create align (TAC, TAL, TAR)
const alignTxtType = alignTxt => {
  switch (alignTxt) {
    // TAC
    case "TAC":
      return "text-align:center";

    // TAL
    case "TAL":
      return "text-align:left";

    // TAR
    case "TAR":
      return "text-align:right";
  }
};



// create align (TAC, TAL, TAR)
const displayElement = display => {
  switch (display) {
    // TAC
    case "DN":
      return "display:none";

    // TAL
    case "DB":
      return "display:block";
  }
};

// create multi color handeler for heading
const handleHeadingType = headingType => {
  switch (headingType) {
    // white txt & image bg
    case "whiteTxtImgBg":
      return "color:${(props) => {return Colors.white;}};";

    // black txt & white bg
    case "default":
      return "color:${(props) => {return Colors.lightBlack;}};";
  }
};


// create width for listing colum
const columWidthType = columWidth => {
  switch (columWidth) {

    // colum 6
    case "colum6":
      return "width:14.28%";

    // colum 5
    case "colum5":
      return "width:16.66%";

    // colum 3
    case "colum2":
      return "width:33%";

    // colum 2
    case "colum1":
      return "width:50%";

    // colum 1
    case "colum0":
      return "width:100%";
  }
};




const ListLi = styled.li`
    ${({ columWidth }) => columWidthType(columWidth)};
    display:inline-block;margin-bottom:20px;padding:0.625rem;
    padding:${props => props.padding};
    margin:${props => props.margin};
    background-color:${props => props.bgColor};
    box-shadow:0px 0px 4px rgba(0, 0, 0, 0.25);border-radius:4px;
    :last-child{margin-bottom:0px}
`;

// create button
const MultiButton = styled(MenuLink)`
    display:inline-block;padding:0.25rem 0.5rem;text-align:center;cursor:pointer;position:relative;border-radius:4px;text-transform:capitalize;
    width:${props => props.width};
    margin:${props => props.margin};
    padding:${props => props.padding};
    border-radius:${props => props.borderRadius};
    font-size: ${(props) => {
    return Size.size12;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw100;
  }};
    ${({ btnType }) => handleBtnType(btnType)};


`;


// create middle warp element
const Card = styled.section`
    padding:0 1rem;
    border-bottom:3px solid rgb(150, 152, 163, 0.3);
    padding:${props => props.padding};
`;



// create heading
const H1 = styled.h1`
    color: ${(props) => {
    return Colors.white;
  }};
    font-size: ${(props) => {
    return Size.size20;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw300;
  }};

    padding:${props => props.padding};
    color:${props => props.color};
    ${({ alignTxt }) => alignTxtType(alignTxt)};

`;


const H2 = styled.h2`
    color: ${(props) => {
    return Colors.black;
  }};
    font-size: ${(props) => {
    return Size.size18;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw300;
  }};

    padding:${props => props.padding};
    strong{font-weight: ${(props) => {
    return FontWeight.fw500;
  }};
    }
    color:${props => props.color};
    ${({ alignTxt }) => alignTxtType(alignTxt)};
`;

const H3 = styled.h3`
    font-size: ${(props) => {
    return Size.size16;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw300;
  }};

    ${({ headingType }) => handleHeadingType(headingType)};
    ${({ alignTxt }) => alignTxtType(alignTxt)};
    padding:${props => props.padding};
    color:${props => props.color};
`;

const H4 = styled.h4`
    font-size: ${(props) => {
    return Size.size14;
  }};
    color: ${(props) => {
    return Colors.lightBlack;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw300;
  }};

    ${({ alignTxt }) => alignTxtType(alignTxt)};
`;

const H5 = styled.h5`
    color:${props => props.color};
    font-size: ${(props) => {
    return Size.size12;
  }};
    font-weight: ${(props) => {
    return FontWeight.fw500;
  }};

    margin:${props => props.margin};
    ${({ alignTxt }) => alignTxtType(alignTxt)};
`;

const IconChanger = styled.span`
    display:inline-block;
    width:${props => props.width};
    margin:${props => props.margin};
    padding:${props => props.padding};
    height:${props => props.height};
    background-size:${props => props.bgSize};
    background-image:url(${props => props.img});
    background-repeat:no-repeat;
    background-position:${props => props.bgPosition};
    background-color:${props => props.bgColor};
    border-radius:${props => props.borderRadius};
    border:${props => props.border};
    position:${props => props.position};
    top:${props => props.top};
    left:${props => props.left};
    right:${props => props.right};
    bottom:${props => props.bottom};
    display:${props => props.display};
    color:${props => props.fontColor};
    font-size:${props => props.fontSize};
    z-index:${props => props.zIndex};
    font-weight:${props => props.fontWeight};
`;


export {
  LHS, RHS, MenuLink, Card, H1, H2, H3, MultiButton, clearFix, H4, IconChanger, H5, Strong, alignTxtType, ListLi, displayElement
};
